import AxiosService from "./axiosServices";
// const axiosService = new AxiosService();

export default class processService {
  getHeaders = () => {
    return {
      headers: {
        "content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };

  getAuditList = (params) => {
    return AxiosService.Get(`api/cam/pc/process-audit-trail-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  getConfigAuditTrailList = (params) => {
    return AxiosService.Get(`api/cam/pc/new-process-audit-trail-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  getConfigurationFiltersList = () => {
    return AxiosService.Get(`api/cam/pc/new-process-audit-trail-dropdowns/`, {
      ...this.getHeaders(),
    });
  };

  getConfigurationVersions = (params) => {
    return AxiosService.Get(`api/cam/pc/new-process-audit-trail-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  exportConfigAuditTrailList = (params) => {
    return AxiosService.Get(
      `api/cam/pc/new-process-audit-trail-list/export/`,
      {
        ...this.getHeaders(),
        params: params,
      },
    );
  };

  getConfigAuditTrailExportStatus = (taskId) => {
    return AxiosService.Get(
      `api/cam/pc/new-process-audit-trail-list/export/status/${taskId}/`,
      {
        ...this.getHeaders(),
      },
    );
  };
}
